// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { MetricIn } from './metricIn.zod.ts';

export const caseCreateInAchievementsOneMax = 20000;

export const caseCreateInAliasesOneItemMax = 200;

export const caseCreateInAliasesOneMax = 20;

export const caseCreateInAnonymizedLabelMax = 120;

export const caseCreateInApproachOneMax = 20000;

export const caseCreateInAssetIdsMax = 50;

export const caseCreateInClientNameOneMax = 200;

export const caseCreateInCountryOneMax = 6;

export const caseCreateInMetricsOneMax = 50;

export const caseCreateInObjectiveOneMax = 20000;

export const caseCreateInSituationOneMax = 20000;

export const CaseCreateIn = zod.object({
  "achievements": zod.union([zod.string().max(caseCreateInAchievementsOneMax),zod.null()]).optional(),
  "aliases": zod.union([zod.array(zod.string().max(caseCreateInAliasesOneItemMax)).max(caseCreateInAliasesOneMax),zod.null()]).optional(),
  "anonymized_label": zod.string().min(1).max(caseCreateInAnonymizedLabelMax),
  "approach": zod.union([zod.string().max(caseCreateInApproachOneMax),zod.null()]).optional(),
  "asset_ids": zod.array(zod.uuid()).max(caseCreateInAssetIdsMax).optional(),
  "client_name": zod.union([zod.string().max(caseCreateInClientNameOneMax),zod.null()]).optional(),
  "country": zod.union([zod.string().max(caseCreateInCountryOneMax),zod.null()]).optional(),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "metrics": zod.union([zod.array(MetricIn).max(caseCreateInMetricsOneMax),zod.null()]).optional(),
  "objective": zod.union([zod.string().max(caseCreateInObjectiveOneMax),zod.null()]).optional(),
  "situation": zod.union([zod.string().max(caseCreateInSituationOneMax),zod.null()]).optional(),
  "status": zod.enum(['live', 'pilot', 'pipeline', 'closed']),
  "type": zod.enum(['client', 'benchmark'])
});

export type CaseCreateIn = zod.input<typeof CaseCreateIn>;
export type CaseCreateInOutput = zod.output<typeof CaseCreateIn>;
